import Button from "@components/common/Button";
import SliderCarousel from "@libs/slider/SliderCarousel";
import useSlider from "@libs/slider/hooks/useSlider";

interface IDetailsLayoutSection {
  title?: string;
  subtitle?: string;
  sliderComponents: JSX.Element[];
  onButtonClick?: any;
}

const SLIDER_CONFIG = {
  desktop: {
    slidesToShow: 1,
  },
  mobile: {
    class: "mobile-carousel",
    variableWidth: true,
  },
};

const DetailsLayoutSection = ({
  title,
  subtitle,
  sliderComponents,
  onButtonClick,
}: IDetailsLayoutSection): JSX.Element => {
  const { sliderSettings } = useSlider(SLIDER_CONFIG);

  return (
    <>
      {title && (
        <h3 className="mb-2 pr-5 text-h6 font-medium desktop:pr-0">{title}</h3>
      )}
      {subtitle && (
        <p className="mb-[26px] pr-5 text-p14 font-normal text-darkgray desktop:pr-0 desktop:text-p">
          {subtitle}
        </p>
      )}
      <SliderCarousel
        key={`${title}_section`}
        components={sliderComponents}
        settings={sliderSettings}
      />
      <div className="mt-[3.125rem] hidden w-[20.25rem] desktop:block">
        <Button onClick={onButtonClick} variant="tertiary">
          <>View All Options</>
        </Button>
      </div>
    </>
  );
};

export default DetailsLayoutSection;
